export default __webpack_public_path__ + "static/media/Caroline.b3efd0fd.jpg";